'use client';

import React, { useState } from 'react';
import { useLocalObservable } from 'mobx-react';
import { useAppService, useConfig, useTheme } from '@ibe/components';
import { ApiSortDirection, ApiSortOption } from '@ibe/api';
import { IbeProps } from '@/components/ibe/IbeProps';
import { CustomPackageSearchStore, CustomPackageStore } from '@/components/ibe/IbeUtils';
import YsnConfigModel from '@/Config/YsnConfigModel';
import { useApi } from '@/Util/useApi';
import Ibe from '@/components/ibe/Ibe';

const IbeWrapper = function IbeWrapper(
  props: Omit<IbeProps, 'store' | 'customPackageSearchStore' | 'isLoading' | 'setIsLoading'>
) {
  const api = useApi();
  const config = useConfig() as YsnConfigModel;
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);

  const customPackageSearchStore = useLocalObservable(
    () => new CustomPackageSearchStore(config, api, theme)
  );

  const appService = useAppService();

  const store = useLocalObservable(
    () =>
      new CustomPackageStore(
        api,
        config,
        {
          sortDirection: ApiSortDirection.ASC,
          sortOption: ApiSortOption.PRICE
        },
        setIsLoading,
        appService
      )
  );

  return (
    <Ibe
      {...props}
      store={store}
      customPackageSearchStore={customPackageSearchStore}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
    />
  );
};

export default IbeWrapper;
